import moment from "moment"

const formatTime=(seconds)=>{
   return moment().startOf('day')
        .seconds(seconds)
        .format('H:mm:ss')
}

export {formatTime}